<template>
  <div class="admin-add-language">
    <error :err.sync="error" />
    <form-generator
      :elements="elements"
      :data="language"
      :handleUpdate="({ key }, v) => (language[key] = v)"
    />
  </div>
</template>

<script>
import languageSchema from "@/validation-schemas/language";
import FormGenerator from "@/components/form-generator.vue";
export default {
  components: { FormGenerator },
  name: "admin-add-language",
  data() {
    return {
      language: {
        name: "",
        iso_code: ""
      },
      error: null,
      loading: false
    };
  },
  computed: {
    elements() {
      return [
        {
          key: "name",
          label: "name",
          type: "string"
        },
        {
          key: "iso_code",
          label: "iso-code",
          type: "string"
        },
        {
          text: "add-language",
          type: "button",
          className: "float-right mt-5 mt-sm-0",
          attrs: {
            loading: this.loading,
            block: this.isSmallScreen
          },
          events: {
            click: this.add
          }
        }
      ];
    }
  },
  methods: {
    async add() {
      this.error = null;
      const { language } = this;
      const validation = languageSchema.validate(language, this.joiOptions);
      if (validation.error) {
        this.error = validation.error.message;
      } else {
        this.loading = true;
        try {
          const res = await this.$store.dispatch("languages/create", {
            ...language,
            parent_language_id: language.parent_language_id
              ? language.parent_language_id.id
              : null
          });
          this.$emit("added", res.data);
          this.language = {
            name: "",
            code: ""
          };
        } catch (err) {
          console.error(err);
        }

        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
